import { render } from "./index.vue?vue&type=template&id=9c3ccdb0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=9c3ccdb0&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c3ccdb0"]])

export default __exports__